import { Label } from './ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import CreatableCombobox from './CreatableCombobox';
import { EquipmentSizeField } from './EquipmentSizeField';
import { equipmentCascadePatch } from '../utils/equipmentSizes';
import { CatalogLoadState } from './CatalogLoadState';

export const EquipmentCatalogFields = ({ item, types, catalog, onPatch, prefix, index, disabled = false, dark = false }) => {
  const id = (key) => `${prefix}-${key}-${index}`;
  const labelClass = dark ? 'text-slate-300' : '';
  const patch = (key, value) => onPatch(equipmentCascadePatch(item, key, value));
  const choices = item.equipment_type && !types.some((t) => t.value === item.equipment_type)
    ? [...types, { value: item.equipment_type, label: catalog.labelForType(item.equipment_type) }] : types;
  const combo = (key, label, options, parent, parentLabel) => <div className="min-w-0 space-y-1.5">
    <Label htmlFor={id(key)} className={labelClass}>{label}</Label>
    <CreatableCombobox value={item[key] || ''} options={options} noun={label.toLowerCase()} dark={dark} testid={id(key)}
      disabled={disabled || (!item[parent] && !item[key])} placeholder={item[parent] ? `Select or type a ${label.toLowerCase()}` : `Select ${parentLabel} first`}
      onChange={(value) => patch(key, value)} />
  </div>;
  return <div className="space-y-3 min-w-0" data-testid={`${prefix}-catalog-${index}`}>
    <CatalogLoadState catalog={catalog} prefix={`${prefix}-catalog-${index}`} />
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      <div className="min-w-0 space-y-1.5"><Label htmlFor={id('type')} className={labelClass}>Equipment Type</Label>
        <Select value={item.equipment_type || 'none'} disabled={disabled || catalog.loading || !!catalog.error} onValueChange={(v) => patch('equipment_type', v === 'none' ? '' : v)}>
          <SelectTrigger id={id('type')} className="min-w-0" data-testid={id('type')}><SelectValue placeholder="Select type" /></SelectTrigger>
          <SelectContent className={`max-w-[90vw] ${dark ? 'dark' : ''}`} data-testid={`${id('type')}-options`}>
            <SelectItem value="none" data-testid={`${id('type')}-none`}>No type</SelectItem>
            {choices.map((t) => <SelectItem key={t.value} value={t.value} data-testid={`${id('type')}-${t.value}`}>{t.label}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      {combo('style', 'Style', catalog.stylesFor(item.equipment_type), 'equipment_type', 'equipment type')}
    </div>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      {combo('make', 'Manufacturer', catalog.manufacturersFor(item.equipment_type, item.style), 'style', 'style')}
      {combo('model', 'Model', catalog.modelsFor(item.equipment_type, item.style, item.make), 'make', 'manufacturer')}
    </div>
    <EquipmentSizeField item={item} catalog={catalog} onChange={(size) => onPatch({ size })} testid={id('size')} disabled={disabled} dark={dark} />
  </div>;
};